import { ref, onMounted, onBeforeUnmount } from 'vue'
import { useRoute } from 'vue-router'

export function useVehicleScrollPosition() {
  const route = useRoute()
  const isRestoringPosition = ref(false)
  const lastVehicleId = ref<string | null>(null)
  const lastScrollPosition = ref<number>(0)
  
  // Save the current scroll position and vehicle ID
  const saveScrollPosition = (vehicleId: string) => {
    if (process.client) {
      const scrollPosition = window.scrollY
      
      // Store in sessionStorage for persistence across page refreshes
      sessionStorage.setItem('vehicleListScrollPosition', scrollPosition.toString())
      sessionStorage.setItem('lastViewedVehicleId', vehicleId)
      
      // Also keep in memory for faster access
      lastScrollPosition.value = scrollPosition
      lastVehicleId.value = vehicleId
      
      console.log(`[ScrollPosition] Saved position ${scrollPosition}px for vehicle ${vehicleId}`)
    }
  }
  
  // Restore the scroll position when returning to the listing page
  const restoreScrollPosition = () => {
    if (!process.client || isRestoringPosition.value) return
    
    // console.log("[ScrollPosition] VehicleScrollPosition.restoreScrollPosition called, but is now disabled to prefer router's native scrollBehavior.");
    // return; // Intentionally disable manual restoration

    isRestoringPosition.value = true
    
    try {
      // Try to get from sessionStorage first (for persistence across refreshes)
      // const savedPosition = sessionStorage.getItem('vehicleListScrollPosition')
      // const savedVehicleId = sessionStorage.getItem('lastViewedVehicleId')
      
      // If we have a saved position, restore it
      // if (savedPosition) {
      //   const position = parseInt(savedPosition, 10)
        
      //   // Use a series of attempts with increasing delays to account for layout shifts
      //   let attempts = 0
      //   const maxAttempts = 5
        
      //   const attemptScroll = () => {
      //     console.log(`[ScrollPosition] Restoring scroll to ${position}px (attempt ${attempts+1})`)
          
      //     window.scrollTo({
      //       top: position,
      //       behavior: 'auto'
      //     })
          
      //     attempts++
          
      //     if (attempts < maxAttempts) {
      //       // Exponential backoff for retry timing
      //       setTimeout(attemptScroll, 100 * Math.pow(1.5, attempts))
      //     }
      //   }
        
      //   // Start with a short delay to allow initial render
      //   setTimeout(attemptScroll, 50)
      // }
      console.log("[VehicleScrollPosition] restoreScrollPosition: Manual scroll restoration logic is disabled.");
    } catch (error) {
      console.error('[ScrollPosition] Error during (disabled) restoreScrollPosition:', error)
    } finally {
      // Clear the restoration flag after a delay
      setTimeout(() => {
        isRestoringPosition.value = false
      }, 1000)
    }
  }
  
  // Check if we're returning from a vehicle detail page
  const isReturningFromVehicleDetail = () => {
    if (!process.client) return false
    
    // Check the referrer URL
    if (document.referrer) {
      try {
        const referrerUrl = new URL(document.referrer)
        return referrerUrl.pathname.startsWith('/vehicle-for-sale/')
      } catch (e) {
        console.error('[ScrollPosition] Error parsing referrer URL:', e)
      }
    }
    
    return false
  }
  
  // Handle popstate events (browser back/forward)
  const handlePopState = () => {
    if (process.client && route.path === '/vehicles') {
      console.log('[VehicleScrollPosition] Detected popstate event. Manual restore is DISABLED.')
      // restoreScrollPosition() // Ensure this is commented out or removed
    }
  }
  
  // Set up event listeners
  onMounted(() => {
    if (process.client) {
      window.addEventListener('popstate', handlePopState)
      
      // Check if we should restore scroll position
      if (route.path === '/vehicles' && isReturningFromVehicleDetail()) {
        console.log('[VehicleScrollPosition] Returning from vehicle detail. Manual restore is DISABLED.')
        // restoreScrollPosition() // Ensure this is commented out or removed
      }
    }
  })
  
  // Clean up event listeners
  onBeforeUnmount(() => {
    if (process.client) {
      window.removeEventListener('popstate', handlePopState)
    }
  })
  
  return {
    saveScrollPosition,
    restoreScrollPosition,
    isRestoringPosition,
    lastVehicleId,
    lastScrollPosition
  }
}
